import React, { useState, useRef, useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiQrCode, FiX, FiUser, FiLoader } = FiIcons;

const QRScanner = ({ onScanSuccess, onClose }) => {
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState('');
  const scannerRef = useRef(null);

  useEffect(() => {
    if (scanning && !scannerRef.current) {
      const scanner = new Html5QrcodeScanner(
        "qr-reader",
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        false
      );

      scanner.render(
        (decodedText) => {
          onScanSuccess(decodedText);
          scanner.clear();
          scannerRef.current = null;
          setScanning(false);
        },
        (error) => {
          setError('Failed to scan QR code. Please try again.');
          console.error(error);
        }
      );

      scannerRef.current = scanner;
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        scannerRef.current = null;
      }
    };
  }, [scanning, onScanSuccess]);

  const startScanning = () => {
    setError('');
    setScanning(true);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-lg p-6 w-full max-w-md"
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Scan Candidate QR Code</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <SafeIcon icon={FiX} className="text-xl" />
          </button>
        </div>

        {!scanning ? (
          <div className="text-center py-8">
            <SafeIcon icon={FiQrCode} className="text-gray-400 text-5xl mx-auto mb-4" />
            <p className="text-gray-600 mb-6">
              Position the QR code within the camera frame to scan the candidate's profile.
            </p>
            <button
              onClick={startScanning}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center space-x-2"
            >
              <SafeIcon icon={FiQrCode} />
              <span>Start Scanning</span>
            </button>
          </div>
        ) : (
          <div className="text-center">
            <div className="mb-4">
              <SafeIcon icon={FiLoader} className="text-blue-600 text-3xl mx-auto animate-spin" />
            </div>
            <p className="text-gray-600 mb-4">Scanning...</p>
            <div id="qr-reader" className="w-full"></div>
          </div>
        )}

        {error && (
          <div className="mt-4 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md">
            {error}
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default QRScanner;